import type { NavItemId } from "../items"

export const texts = {
  ariaLabel: "Navegación principal",
  comingSoon: "Pronto",
  items: {
    casino: "Casino",
    sports: "Deportes",
    tournaments: "Torneos",
    promotions: "Promociones",
    vip: "VIP"
  } satisfies Record<NavItemId, string>
}
